const Home = {
    text: 'Posts',
    //link: '/home',
    icon: 'assets/img/post_navicon_active.svg'
};

// const Dashboard = {
//     text: 'Archive',
//     //link: '/dashboard',
//     icon: 'assets/img/archive_navicon_inactive.svg'
// };

export const menu = [
    Home,
   //  Dashboard,
];



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/routes/menu.ts